module.exports = __webpack_public_path__ + "media/agora-outgoing-call.75c32e77.wav";